export default {
  defaultObject () {
    return {
      id: null,
      name: '',
      trailerStyle: '',
      plannedMonthlyMileage: null,
      serviceInterval: null,
      height: null,
      weight: null,
      tailLift: false,
      moffetMounts: false,
      group: '',
      vehicleType: '',
      vehicleMake: '',
      ebsValveType: '',
      vehicleGrossWeight: '',
      customFields: []
    }
  }
}